import { ILanguageSkill } from './language-skill.model';
import { Language } from './enumerations/language.model';

// Persisted category codes; these are not an ascending proficiency scale.
export const GERMAN_LANGUAGE_LEVELS = [3, 2, 6];

export function isGerman(language: string): boolean {
  return language?.toUpperCase() === 'GERMAN';
}

export function languageLevelOptions(skill: ILanguageSkill, otherLanguageLevels: number[] = [1, 2, 3, 4, 5]): number[] {
  return isGerman(skill.language) ? [...GERMAN_LANGUAGE_LEVELS] : [...otherLanguageLevels];
}

export function languageLevelKey(skill: ILanguageSkill): string {
  const group = isGerman(skill.language) ? 'germanLevels' : 'levels';
  return `care4YouApp.languageSkill.${group}.${skill.level == null ? 'null' : skill.level}`;
}

export function germanLanguageLevelKey(skills?: ILanguageSkill[] | null): string {
  return languageLevelKey(skills?.find(skill => isGerman(skill.language)) || { language: Language.GERMAN });
}
